import { render, staticRenderFns } from "./AdminClaims.vue?vue&type=template&id=a533c0b6&scoped=true"
import script from "./AdminClaims.vue?vue&type=script&lang=js"
export * from "./AdminClaims.vue?vue&type=script&lang=js"
import style0 from "./AdminClaims.vue?vue&type=style&index=0&id=a533c0b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a533c0b6",
  null
  
)

export default component.exports